const slideAnimation = {
  slideLeft: {
    opacity: 0,
    x: '100%',
  },
  visible: {
    opacity: 1,
    x: 0,
  },
  slideRight: {
    opacity: 0,
    x: '-100%',
  },
}

export { slideAnimation }
